<template>
  <div class="container page victoria-record-page game-record-page">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" pulling-text=" " loosing-text=" " loading-text="...">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
        <div v-else class="item_list" v-for="(v,key) in list" :key="key">
          <div class="lottery_info">
            <span class="period-number">{{v.expect}}</span>
          </div>
          <div class="recent">
            <div class="kuaisan-ball left">
              <span class="res-des middle">{{v.buystr}}</span>
            </div>
          </div>

          <div class="time">
            <span style="color: red;">{{$t("reservation.money")}}：{{v.money}}</span>
          </div>
          <div class="time">
            <span>{{$t("reservation.order_time")}}：{{v.create_time}}</span>
          </div>
          <div class="time">
            <span>{{$t("reservation.settle_time")}}：{{v.update_time}}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list:[]
    };
  },
  methods: {
    getBigSmallText(v) {
      if(v.status === 0) return 0;
      const sum = v.opencode[0] + v.opencode[1] + v.opencode[2];
      return sum >= 11 && sum <= 18 ? this.$t("reservation.big") : this.$t("reservation.samll");
    },
    getDoubleText(v) {
      if(v.status === 0) return 0;
      const sum = v.opencode[0] + v.opencode[1] + v.opencode[2];
      return sum % 2 === 0 ? this.$t("reservation.double") : this.$t("reservation.single");
    },
    back(){
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserGameList(){
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res=>{
        if(res.code === 200){
          this.list = res.data.map(item => {
            let buystr = '';
            item.data.map(i => {
              buystr += i.type + ', ';
            });
            item.buystr = buystr.slice(0, -2);
            return item;
          });
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }

  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserGameList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 0.35rem;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 0.35rem;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #f2f2f5;
  height: 100%;
  padding: 0 0.1rem;
}
.item_list{
  padding: 0.15rem 0.15rem;
  margin: 0.3rem 0.1rem;
  background: #fff;
  border-radius: 0.1rem;
  line-height: 0.6rem;
}

.item_list .topInfo span{
  flex: 1;
  font-size: 0.35rem;
  font-weight: 700;
  color: #ff253f;
}
.item_list .time span{
  flex: 1;
  font-size: 0.35rem;
  font-weight: 500;
  color: #000;
}

.item_list .topInfo span:last-child{
  float: right;
}
.item_list .desc span{
  font-size: 0.25rem;
  font-weight: 700;
  color: #9b9b9b;
}
.item_list .cover{
  width: 0.6rem;
  height: 0.6rem;
  -o-object-fit: cover;
  object-fit: cover;
}
.item_list  .period-number{
  margin-right: 0.1rem;
  height: 0.5rem;
  line-height: 0.6rem;
  font-size: 0.45rem;
  font-weight: 700;
  color: #000;
}
.item_list .lottery_info{
  display: flex;
}
.recent {
  display: flex;
  align-items: center;
  height: 1rem;
}
.kuaisan-ball .left{
  justify-content: flex-start;
}
.kuaisan-ball{
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img{
  width: 0.7rem;
  height: 0.7rem;
  margin-right: 0.3rem;
}
.kuaisan-ball .res-des{
  font-weight: 700;
  text-align: left;
  color: #000;
}
.kuaisan-ball .res-des.middle{
  width: 100%;
  font-size: 0.4rem;
  text-align: left;
  text-transform: capitalize;

}
</style>
